<template>
  <div class="text-end">
    <router-link to="/vbots">
      <button class="float-right btn btm-sm btn-success">
        Back to list
      </button>
    </router-link>
  </div>

  <div class="p-4">
    <Form role="form" @submit="handleAdd">
      <!-- Tab Navigation -->
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-bs-toggle="tab" href="#general">
            Allgemein
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#sip">
            SIP-Einstellungen
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#ai">
            KI-Modelle
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#network">
            Netzwerk
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#email">
            E-Mail
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#advanced">
            Erweitert
          </a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content mt-4">
        <!-- ALLGEMEIN TAB -->
        <div id="general" class="tab-pane fade show active">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Bezeichnung
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Bezeichnung</strong>
                      Der eindeutige Name für Ihren Phonebot. Dieser wird in der Übersicht angezeigt und hilft bei der Identifikation.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.bezeichnung"
                  name="bezeichnung"
                  id="bezeichnung"
                />
                <ErrorMessage name="bezeichnung" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Product Name
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Produktversion</strong>
                      <strong>Basic:</strong> Grundfunktionen für einfache Anrufe<br>
                      <strong>Advanced:</strong> Erweiterte KI-Features und Integrationen
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.product_name" name="product_name" id="product_name">
                  <option value="" disabled>Select Product Name</option>
                  <option value="KI-Phone-Basic">KI-Phone-Basic</option>
                  <option value="KI-Phone-Advanced">KI-Phone-Advanced</option>
                </Field>
                <ErrorMessage name="product_name" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group input-group-static mb-4">
                <label>
                  Ansagetext
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Begrüßungstext</strong>
                      Der erste Text, den Anrufer hören. Sollte freundlich und informativ sein. Beispiel: "Willkommen bei [Firma], wie kann ich Ihnen helfen?"
                    </div>
                  </span>
                </label>
                <textarea
                  class="form-control"
                  v-model="vbot.ansagetext"
                  name="ansagetext"
                  id="ansagetext"
                  rows="2"
                ></textarea>
                <ErrorMessage name="ansagetext" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group input-group-static mb-4">
                <label>
                  Prompt
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>KI-Systemanweisung</strong>
                      Definiert das Verhalten und die Persönlichkeit der KI. Beschreiben Sie die Rolle, den Ton und die Aufgaben des Bots.
                    </div>
                  </span>
                </label>
                <textarea
                  class="form-control"
                  v-model="vbot.prompt"
                  name="prompt"
                  id="prompt"
                  rows="8"
                ></textarea>
                <ErrorMessage name="prompt" class="text-danger" />
              </div>
            </div>
          </div>
        </div>

        <!-- SIP TAB -->
        <div id="sip" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Benutzername
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SIP-Authentifizierung</strong>
                      Der Benutzername für die SIP-Registrierung bei Ihrem VoIP-Provider. Wird vom Provider bereitgestellt.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_benutzername"
                  name="sip_benutzername"
                  id="sip_benutzername"
                />
                <ErrorMessage name="sip_benutzername" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Password
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SIP-Passwort</strong>
                      Das zugehörige Passwort für die SIP-Authentifizierung. Wird sicher verschlüsselt gespeichert.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_passwd"
                  name="sip_passwd"
                  id="sip_passwd"
                />
                <ErrorMessage name="sip_passwd" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Registername
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Registrierungsname</strong>
                      Optional: Ein alternativer Name für die SIP-Registrierung, falls vom Provider gefordert.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_registername"
                  name="sip_registername"
                  id="sip_registername"
                />
                <ErrorMessage name="sip_registername" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Telefonnummer
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Rufnummer</strong>
                      Die Rufnummer für die KI.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_phonenumber"
                  name="sip_phonenumber"
                  id="sip_phonenumber"
                />
                <ErrorMessage name="sip_phonenumber" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SIP-Server-Adresse</strong>
                      Die Domain oder IP-Adresse Ihres VoIP-Providers (z.B. sip.provider.com).
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_server"
                  name="sip_server"
                  id="sip_server"
                />
                <ErrorMessage name="sip_server" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Port
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Port-Nummer</strong>
                      Standard ist 5060 (unverschlüsselt) oder 5061 (TLS verschlüsselt).
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_port"
                  name="sip_port"
                  id="sip_port"
                />
                <ErrorMessage name="sip_port" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  SIP Registrierungsintervall (Sekunden)
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Registrierungsintervall</strong>
                      Zeitspanne, nach der sich der SIP-Client automatisch neu beim Server anmeldet, um die Verbindung aktiv zu halten.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.sip_registrierungsinterval"
                  name="sip_registrierungsinterval"
                  id="sip_registrierungsinterval"
                />
                <ErrorMessage name="sip_registrierungsinterval" class="text-danger" />
              </div>
            </div>
            
          </div>
          
        </div>

        

        <!-- KI-MODELLE TAB -->
        <div id="ai" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Chatmodel
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>KI-Sprachmodell</strong>
                      GPT-4o: Beste Qualität | gpt-4o-mini: Ausgewogen
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.chatmodel" name="chatmodel" id="chatmodel">
                  <option value="gpt-4o">gpt-4o</option>
                  <option value="gpt-5">gpt-5</option>
                  <option value="gpt-5-mini">gpt-5-mini</option>
                  <option value="gpt-5-nano">gpt-5-nano</option>
                  <option value="gpt-4.1">gpt-4.1</option>
                  <option value="gpt-4.1-mini">gpt-4.1-mini</option>
                  <option value="gpt-4.1-nano">gpt-4.1-nano</option>
                  <option value="gpt-4o-mini">gpt-4o-mini</option>
                  <option value="gpt-4-turbo">gpt-4-turbo</option>
                  <option value="gpt-4">gpt-4</option>
                  <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>
                  <option value="o1">o1</option>
                  <option value="o1-mini">o1-mini</option>
                  <option value="o3">o3</option>
                  <option value="o3-mini">o3-mini</option>
                  <option value="o4-mini">o4-mini</option>
                  <option value="gpt-realtime">gpt-realtime</option>
                  <option value="gpt-4o-realtime-preview">gpt-4o-realtime-preview</option>
                  <option value="gpt-4o-mini-realtime-preview">gpt-4o-mini-realtime-preview</option>
                  <option value="gpt-realtime-mini">gpt-realtime-mini</option>
                </Field>
                <ErrorMessage name="chatmodel" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Voice für OpenAI
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Stimmprofil</strong>
                      Stimme für Sprachausgabe.
                      Männliche Stimmen: Ash, Echo, Ballad, Verse
                      Weibliche Stimmen: Shimmer, Sage, Coral
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.voice" name="voice" id="voice">
                  <option value="shimmer">Shimmer</option>
                  <option value="ash">Ash</option>
                  <option value="echo">Echo</option>
                  <option value="ballad">Ballad</option>
                  <option value="verse">Verse</option>
                  <option value="sage">Sage</option>
                  <option value="coral">Coral</option>
                </Field>
                <ErrorMessage name="voice" class="text-danger" />
              </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  STT Model
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Speech-to-Text</strong>
                      Spracherkennung: Sprache → Text
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.sttmodel" name="sttmodel" id="sttmodel">
                  <option value="OpenAI">OpenAI</option>
                  <option value="Microsoft">Microsoft</option>
                  <option value="Voxtral">Voxtral</option>
                </Field>
                <ErrorMessage name="sttmodel" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TTS Model
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Text-to-Speech</strong>
                      Sprachsynthese: Text → Sprache
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.ttsmodel" name="ttsmodel" id="ttsmodel">
                  <option value="OpenAI">OpenAI</option>
                  <option value="Microsoft">Microsoft</option>
                </Field>
                <ErrorMessage name="ttsmodel" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Temperatur
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>KI-Kreativität</strong>
                      0.1-0.3: Konsistent | 0.5-0.8: Ausgewogen | 1.0+: Kreativ<br>
                      <strong>Bereich:</strong> Realtime: 0.6-1.2 | Standard: 0.0-2.0
                    </div>
                  </span>
                </label>
                <Field
                  type="number"
                  class="form-control"
                  v-model="vbot.temperature"
                  name="temperature"
                  id="temperature"
                  :min="temperatureMin"
                  :max="temperatureMax"
                  :step="0.1"
                />
                <small class="form-text text-muted">
                  Erlaubter Bereich: {{ temperatureMin }} - {{ temperatureMax }}
                </small>
                <ErrorMessage name="temperature" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="forwarding_through_openai_tool">
                  Forwarding Through OpenAI Tool
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>OpenAI Tool Forwarding</strong>
                      Weiterleitung via OpenAI Tools.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.forwarding_through_openai_tool" name="forwarding_through_openai_tool" id="forwarding_through_openai_tool" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="websearch_openai">
                  Activate Websearch in OpenAI
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Web-Suche</strong>
                      Aktiviert Web-Suche für OpenAI.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.websearch_openai" name="websearch_openai" id="websearch_openai" />
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- NETZWERK TAB -->
        <div id="network" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TransportType
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Transportprotokoll</strong>
                      <strong>UDP:</strong> Schnell, Standard<br>
                      <strong>TCP:</strong> Zuverlässiger<br>
                      <strong>TLS:</strong> Verschlüsselt, sicher
                    </div>
                  </span>
                </label>
                <Field as="select" class="form-control" v-model="vbot.transmit_type" name="transmit_type" id="transmit_type">
                  <option value="" disabled>Select TransportType</option>
                  <option value="tcp">tcp</option>
                  <option value="udp">udp</option>
                  <option value="tls">tls</option>
                  <option value="stcp">stcp</option>
                </Field>
                <ErrorMessage name="transmit_type" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  STUN Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>NAT-Traversal</strong>
                      STUN-Server helfen bei der Verbindung hinter Firewalls. Format: stun:stun.example.com
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.stun_server"
                  name="stun_server"
                  id="stun_server"
                />
                <ErrorMessage name="stun_server" class="text-danger" />
              </div>
            </div>
          </div>
          
          
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TURN Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>TURN Server</strong>
                      Relay-Server für NAT-Traversal in komplexen Netzwerken.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.turnserver"
                  name="turnserver"
                  id="turnserver"
                />
                <ErrorMessage name="turnserver" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Outbound Proxy
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Proxy-Server</strong>
                      Optional: Outbound Proxy für SIP-Verkehr.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.OutboundProxy"
                  name="OutboundProxy"
                  id="OutboundProxy"
                />
                <ErrorMessage name="OutboundProxy" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TURN Server Username
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>TURN Benutzername</strong>
                      Benutzername für TURN-Server Authentifizierung.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.nat_username"
                  name="nat_username"
                  id="nat_username"
                />
                <ErrorMessage name="nat_username" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  TURN Server Password
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>TURN Passwort</strong>
                      Passwort für TURN-Server Authentifizierung.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.nat_password"
                  name="nat_password"
                  id="nat_password"
                />
                <ErrorMessage name="nat_password" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">       
            <div class="col-md-4">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="useSRTP">
                  Use SRTP
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Verschlüsselung</strong>
                      SRTP verschlüsselt Sprachdaten.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="vbot.useSRTP" name="useSRTP" id="useSRTP" />
                </div>
              </div>
            </div>
          </div>
        </div>
      

        <!-- EMAIL TAB -->
        <div id="email" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Server
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SMTP-Server</strong>
                      Der SMTP-Server für den E-Mail-Versand (z.B. smtp.gmail.com, smtp.office365.com).
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.e_mail_server"
                  name="e_mail_server"
                  id="e_mail_server"
                />
                <ErrorMessage name="e_mail_server" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Server Port
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>SMTP-Port</strong>
                      Standard-Ports: 587 (TLS), 465 (SSL), 25 (unverschlüsselt, nicht empfohlen).
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.e_mail_server_port"
                  name="e_mail_server_port"
                  id="e_mail_server_port"
                />
                <ErrorMessage name="e_mail_server_port" class="text-danger" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email User
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>E-Mail-Adresse</strong>
                      Die E-Mail-Adresse, die zum Versenden verwendet wird. Meist identisch mit dem Login.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.e_mail_user"
                  name="e_mail_user"
                  id="e_mail_user"
                />
                <ErrorMessage name="e_mail_user" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Password
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>E-Mail-Passwort</strong>
                      Das Passwort oder App-Passwort für den E-Mail-Account. Bei Gmail/Outlook oft ein spezielles App-Passwort erforderlich.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.e_mail_passwd"
                  name="e_mail_passwd"
                  id="e_mail_passwd"
                />
                <ErrorMessage name="e_mail_passwd" class="text-danger" />
              </div>
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group input-group-static mb-4">
                <label>
                  Email Server From
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Absender-Adresse</strong>
                      Die E-Mail-Adresse, die als Absender angezeigt wird.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.e_mail_server_from"
                  name="e_mail_server_from"
                  id="e_mail_server_from"
                />
                <ErrorMessage name="e_mail_server_from" class="text-danger" />
              </div>
            </div>
          </div>
        <div>
          <div class="col-md-4">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="mail_certifikate_validation">
                  Mail Certificate Validation
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Zertifikatsprüfung</strong>
                      Validiert SSL/TLS-Zertifikate beim E-Mail-Versand.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="vbot.mail_certifikate_validation"
                    name="mail_certifikate_validation"
                    id="mail_certifikate_validation"
                    />
                </div>
              </div>
            </div>
        </div>
        

        </div>



        <!-- ERWEITERT TAB -->
        <div id="advanced" class="tab-pane fade">
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  PromptXT-URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Externe Prompt-Quelle</strong>
                      URL zu einer externen Prompt-Datei.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.prompturl"
                  name="prompturl"
                  id="prompturl"
                />
                <ErrorMessage name="prompturl" class="text-danger" />
              </div>
            </div>
                      <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Outbound List URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Outbound-Liste</strong>
                      URL zur Outbound-Anrufliste.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.outbound_list_url"
                  name="outbound_list_url"
                  id="outbound_list_url"
                />
                <ErrorMessage name="outbound_list_url" class="text-danger" />
              </div>
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Flowise URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Flowise Integration</strong>
                      Optional: URL zu Ihrem Flowise-Workflow für erweiterte KI-Funktionen und Integrationen.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.flowiseurl"
                  name="flowiseurl"
                  id="flowiseurl"
                />
                <ErrorMessage name="flowiseurl" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  n8n URL
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>n8n Integration</strong>
                      Optional: URL zu Ihrem n8n-Workflow für erweiterte KI-Funktionen und Integrationen.
                    </div>
                  </span>
                </label>
                <Field
                  type="text"
                  class="form-control"
                  v-model="vbot.n8n_url"
                  name="n8n_url"
                  id="n8n_url"
                />
                <ErrorMessage name="n8n_url" class="text-danger" />
              </div>
            </div>
            
          </div>
          
          <div class="row">
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="attendedTransfer">
                  Attended Transfer
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Attended Transfer</strong>
                      Ermöglicht beaufsichtigte Anrufweiterleitungen.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="vbot.attendedTransfer"
                    name="attendedTransfer"
                    id="attendedTransfer"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label>
                  Time until call abort (seconds)
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Timeout-Einstellung</strong>
                      Nach wie vielen Sekunden soll ein nicht angenommener Anruf automatisch beendet werden?
                    </div>
                  </span>
                </label>
                <Field
                  type="number"
                  class="form-control"
                  v-model="vbot.abort_time"
                  name="abort_time"
                  id="abort_time"
                />
                <ErrorMessage name="abort_time" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group input-group-static mb-4">
                <label class="form-check-label" for="web_log_enabled">
                  Web-Log
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Web-Logging</strong>
                      Aktiviert das Logging im Web-Interface.
                    </div>
                  </span>
                </label>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="vbot.web_log_enabled"
                    name="web_log_enabled"
                    id="web_log_enabled"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-4">
                <label class="form-label d-block">
                  Category Terms (Max 5)
                  <span class="info-icon">
                    i
                    <div class="info-tooltip">
                      <strong>Kategorie-Begriffe</strong>
                      Bis zu 5 Begriffe zur Kategorisierung des Phonebots.
                    </div>
                  </span>
                </label>
                <div v-for="(term, index) in vbot.category_terms" :key="index" class="d-flex align-items-center mb-2">
                  <div class="flex-grow-1 input-group input-group-static">
                    <Field
                      type="text"
                      class="form-control border-0 border-bottom"
                      v-model="vbot.category_terms[index]"
                      :name="'category_terms_' + index"
                      :id="'category_terms_' + index"
                      @input="handleInputChange(index)"
                    />
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger ms-2"
                    @click="deleteCategoryTerm(index)"
                    v-if="vbot.category_terms.length > 1"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
                <ErrorMessage name="category_terms" class="text-danger" />
                <button
                  v-if="vbot.category_terms.length < 5"
                  type="button"
                  class="btn btn-sm btn-primary mt-2"
                  @click="addCategoryTerm"
                >
                  <i class="fas fa-plus"></i> Add Term
                </button>
                <div v-else>
                  <small class="text-muted">Maximum 5 category terms allowed.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
    

      <div class="button-row d-flex justify-content-end mt-4">
        <button class="btn btn-sm btn-dark">
          Add Phonebot
        </button>
      </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import userService from "@/services/users.service";
import showSwal from "@/mixins/showSwal";

export default {
  name: "Info1",
  components: {
    Form,
    Field,
    ErrorMessage
  },
  data() {
    return {
      vbot: {
        category_terms: [],
        web_log_enabled: true,
        abort_time: 30,
        voice: "shimmer",
        forwarding_through_openai_tool: false,
        websearch_openai: false,
        sttmodel: "OpenAI", // Default STT model
        ttsmodel: "OpenAI", // Default TTS model
        chatmodel: "gpt-realtime-mini", // Default chat model
        sip_registrierungsinterval: 120, // Default registration interval
      },
      role: '',
    };
  },
  async mounted() {
    await this.fetchRole();
  },
  computed: {
    temperatureMin() {
      return this.vbot.chatmodel && this.vbot.chatmodel.includes('realtime') ? 0.6 : 0;
    },
    temperatureMax() {
      return this.vbot.chatmodel && this.vbot.chatmodel.includes('realtime') ? 1.2 : 2;
    }
  },
  methods: {
    async handleAdd() {
      this.vbot['role'] = this.role;
      try {
        await this.$store.dispatch('vbot/addVbot', this.vbot);
        showSwal.methods.showSwal({
          type: "success",
          message: "Phonebot Created Successfully", 
          width: 500,
          timer: 160000,
          showConfirmButton: true
        });
        this.$router.push({ name: 'vbots' });
      } catch (error) {
        console.error('Signup error:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Error in creating Phonebot!",
          width: 500
        });
      }
    },
    async fetchRole() {
      try {
        const response = await userService.fetchRole();
        this.role = response.role;
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    addCategoryTerm() {
      if (this.vbot.category_terms.length < 5) {
        this.vbot.category_terms.push("");
      }
    },
    deleteCategoryTerm(index) {
      if (this.vbot.category_terms.length > 1) {
        this.vbot.category_terms.splice(index, 1);
      }
    },
    handleInputChange(index) {
      let term = this.vbot.category_terms[index];
      if (term && term.startsWith('"') && term.endsWith('"')) {
        this.vbot.category_terms[index] = term.slice(1, -1);
      }
    },
  },
};
</script>

<style scoped>
/* Weißer Hintergrund für alle Input-Felder */
.form-control {
  background-color: #ffffff !important;
}

/* Weißer Hintergrund für Textareas */
textarea.form-control {
  background-color: #ffffff !important;
}

/* Weißer Hintergrund für Select-Felder */
select.form-control {
  background-color: #ffffff !important;
}

/* Weißer Hintergrund für den gesamten Tab-Content-Bereich */
.tab-content {
  background-color: #ffffff;
}

.tab-pane {
  background-color: #ffffff;
}

.input-group-static label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #17a2b8;
  color: white;
  font-size: 11px;
  font-weight: bold;
  cursor: help;
  position: relative;
  transition: all 0.3s;
}

.info-icon:hover {
  background: #138496;
  transform: scale(1.1);
}

.info-tooltip {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background: #2c3e50;
  color: white;
  padding: 10px 15px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: normal;
  white-space: normal;
  width: 250px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  line-height: 1.4;
}

.info-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #2c3e50;
}

.info-icon:hover .info-tooltip {
  opacity: 1;
  visibility: visible;
  bottom: 135%;
}

.info-tooltip strong {
  display: block;
  margin-bottom: 5px;
  color: #3498db;
}

.nav-tabs .nav-link {
  color: #495057;
}

.nav-tabs .nav-link.active {
  font-weight: 600;
}
</style>